import { Doughnut } from 'react-chartjs-2';

interface DoughnutChartProps {
  chartData: any;
  heading: string;
}

const getChart = (data: any) => {
  if (data.datasets[0].data.every((value: number) => value === 0)) {
    return (
      <div className="border-color-brand-light-gray h-[15rem] w-[15rem] rounded-[10rem] border-[3rem]"></div>
    );
  }

  return (
    <Doughnut
      data={data}
      options={{
        plugins: {
          title: {
            display: true,
          },
          legend: {
            display: false,
          },
        },
      }}
    />
  );
};
const DoughnutChart = ({ chartData, heading }: DoughnutChartProps) => {
  return (
    <div className="flex h-full max-w-[100vw] flex-col gap-[1.6rem]">
      <h2 className="whitespace-nowrap text-[1.8rem] font-semibold">
        {heading}
      </h2>
      <div className="flex grow items-center justify-center">
        {getChart(chartData)}
      </div>
      <div className="flex flex-col gap-[1.6rem]">
        {chartData.labels.map((label: string, index: number) => (
          <div className="flex items-center gap-[1.6rem]" key={label}>
            <div
              className="h-[1.6rem] w-[1.6rem] rounded-full"
              style={{
                backgroundColor: chartData.datasets[0].backgroundColor[index],
              }}
            />
            <p className="text-[1.6rem]">{label}</p>
            <p className="grow"></p>
            <p className="font-semibold text-[1.rem]">
              {chartData.datasets[0].data[index]}
            </p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default DoughnutChart;
